import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { ClienteAnaliseMercadoClienteModule } from '../../cliente';

import { ClienteAnaliseMercadoPerspectivaClassificacaoComponent } from './cliente-analise-mercado-perspectiva-classificacao.component';

@NgModule({
    imports: [
        SharedModule,
        ClienteAnaliseMercadoClienteModule
    ],
    declarations: [
        ClienteAnaliseMercadoPerspectivaClassificacaoComponent
    ],
    exports: [
        SharedModule,

        ClienteAnaliseMercadoPerspectivaClassificacaoComponent
    ],
    providers: [ ]
})
export class ClienteAnaliseMercadoPerspectivaClassificacaoModule { }
